import React from 'react'
import s from './ExpenseReport.less'
import T from '../i18n/T'
import { useSelector } from 'react-redux'
import { selectRoadbookSummary } from '../../store/itinerary/expenseReport.selectors'

const ExpenseReportSummarySection = () => {
  const summary = useSelector(selectRoadbookSummary)

  return (
    <div className={s.block}>
      <h2>
        <T id={'itinerary.expense.summary-title'} />
      </h2>
      <div>
        <strong>
          <T id={'itinerary.expense.departure-time'} />
        </strong>{' '}
        : {summary?.departureTimeLabel?.day} <T id={'itinerary.expense.time-at'} /> {summary?.departureTimeLabel?.hour}
      </div>
      <hr className={s.smallBar} />
      <div>
        <strong>
          <T id={'itinerary.expense.arrival-time'} />
        </strong>{' '}
        : {summary?.arrivalTimeLabel?.day} <T id={'itinerary.expense.time-at'} /> {summary?.arrivalTimeLabel?.hour}
      </div>
      <hr className={s.smallBar} />
      <div>
        <strong>
          <T id={'itinerary.expense.duration'} />
        </strong>{' '}
        : {summary.duration} <T id={'itinerary.expense.duration-details'} />
      </div>
      <hr className={s.smallBar} />
      <div>
        <strong>
          <T id={'itinerary.expense.length'} />
        </strong>{' '}
        : {summary.distance}
      </div>
    </div>
  )
}

export default ExpenseReportSummarySection
